export const YOUR_API_KEY="AIzaSyCo_4zK_GAIROKvLU4YDqnjaS_NYWKJjV4"
export const YOUTUBE_API_URL="https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key="+ YOUR_API_KEY

export const YOUTUBE_SEARCH_API =
  "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q="

  export const LIVE_CHAT_COUNT=25;